import {useTranslation} from "react-i18next";
import {Dialog, DialogActions, DialogContent, DialogTitle, useMediaQuery} from "@material-ui/core";
import React, {useEffect, useState} from "react";
import {OrganizationUnitSelector} from "./OrganizationUnitSelector";
import Button from "@material-ui/core/Button";
import {GreyedOutProgressMask} from "../../ui/GreyedOutProgressMask";
import {OrgUnit} from "../../../models/organization";

interface Props {
    open: boolean,
    onSelectOrgUnit: (orgUnit: OrgUnit) => void,
    onCancel: () => void
    organizationId: number
    initialSelectedOrgUnit?: { id: number, name: string },
    disabled?: boolean,
    titleKey?: string
}

const defaultTitleKey = 'Subscription.DistributeSubscriptions.SelectDestination';

export const OrganizationUnitSelectorDialog: React.FC<Props> = ({open, onSelectOrgUnit, onCancel, disabled = false, initialSelectedOrgUnit, organizationId, titleKey = defaultTitleKey}) => {
    const {t} = useTranslation();
    const displayFullScreenSelector = useMediaQuery((theme: any) => theme.breakpoints.down('md'));
    const [selectedOrgUnit, setSelectedOrgUnit] = useState<{ id: number, name: string } | undefined>(initialSelectedOrgUnit);

    useEffect(() => {
        setSelectedOrgUnit(initialSelectedOrgUnit);
    }, [initialSelectedOrgUnit]);

    const changeSelectedOrgUnitId = (orgUnit?: OrgUnit) => {
        setSelectedOrgUnit(orgUnit);
    };

    const selectOrgUnit = () => {
        if (!!selectedOrgUnit)
            onSelectOrgUnit(selectedOrgUnit);
    };
    const cancelOrgUnitSelection = () => {
        if (!!initialSelectedOrgUnit)
            onSelectOrgUnit(initialSelectedOrgUnit);
        onCancel();
    };
    return <Dialog onClose={selectOrgUnit} open={open} fullScreen={displayFullScreenSelector}
                   disableBackdropClick>
        <DialogTitle>
            {t(titleKey)}
        </DialogTitle>
        <DialogContent>
            <GreyedOutProgressMask isActive={disabled} displaySpinner={disabled}>
                <OrganizationUnitSelector organizationId={organizationId} selectedId={selectedOrgUnit?.id}
                                          onSelectedOrganizationUnitChanged={changeSelectedOrgUnitId}/>
            </GreyedOutProgressMask>
        </DialogContent>
        <DialogActions>
            <Button onClick={cancelOrgUnitSelection} disabled={disabled} color="primary" variant="outlined">
                {t('_Common.Labels.Cancel')}
            </Button>
            <Button onClick={selectOrgUnit} disabled={disabled} color="primary" variant="contained">
                {t('Subscription.DistributeSubscriptions.SelectThisOrgUnit')}
            </Button>
        </DialogActions>
    </Dialog>;
};
